// From /packages/theme/style/variables.scss
export var PORTRAIT = 480;
export var TABLET = 768;
export var DESKTOP = 992;
export var WIDESCREEN = 1200;
export var HEADER = 900;
export var portrait = "(max-width: ".concat(PORTRAIT - 1, "px)");
export var landscape = "(min-width: ".concat(PORTRAIT, "px)");
export var mobile = "(max-width: ".concat(TABLET - 1, "px)");
export var tablet = "(min-width: ".concat(TABLET, "px) and (max-width: ").concat(DESKTOP - 1, "px)");
export var mobileAndTablet = "(max-width: ".concat(DESKTOP - 1, "px)");
export var desktopAndTablet = "(min-width: ".concat(TABLET, "px)");
export var desktop = "(min-width: ".concat(DESKTOP, "px)");
export var widescreen = "(min-width: ".concat(WIDESCREEN, "px)");
export var header = "(min-width: ".concat(HEADER, "px)");
//# sourceMappingURL=media-queries.js.map